'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports['default'] = void 0;

var _Tree = _interopRequireDefault(require('./Tree'));

var _default = _Tree['default'];
exports['default'] = _default;
